import { RSAA } from 'redux-api-middleware';
import { nanoid } from 'nanoid';

import { PushToRouteOneStatus, type StateTree } from '@makemydeal/dr-dash-types';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import {
    CLEAR_PUSH_TO_ROUTEONE_CACHE,
    CONFIRM_PUSH_TO_ROUTEONE,
    PUSH_TO_ROUTEONE_FAILURE,
    PUSH_TO_ROUTEONE_REQUEST,
    PUSH_TO_ROUTEONE_SUCCESS,
    UPDATE_PUSH_TO_ROUTEONE
} from '../actionTypes/pushToRouteOneActionTypes';
import { getDealXgId, getDealXgVersion, getDealRefIdFS, getCurrentOfferType } from '../selectors/offerRedux';
import { getSelectedCreditDecision } from '../selectors/creditDecisionSelectors';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { getContractingSourcePartnerId } from './contractingActionCreators';

export const confirmPushToRouteOne = () => {
    return {
        type: CONFIRM_PUSH_TO_ROUTEONE
    };
};

export const updatePushToRouteOne = ({ timestamp, dealXgVersion: _dealXgVersion, message, ok }: any) => {
    const status: string = ok ? PushToRouteOneStatus.Success : PushToRouteOneStatus.Failure;
    return {
        type: UPDATE_PUSH_TO_ROUTEONE,
        payload: {
            timestamp,
            message,
            ok,
            status
        }
    };
};

export const updatePushToRouteOneFailureStatus = () => {
    return {
        type: PUSH_TO_ROUTEONE_FAILURE,
        payload: {
            message: 'Failed to Push to Route One',
            ok: false
        }
    };
};

export const clearPushToRouteOneCache = () => {
    return {
        type: CLEAR_PUSH_TO_ROUTEONE_CACHE
    };
};

export const pushToRouteOneRSAA = (
    appPrefix: string,
    state: StateTree,
    overrides: { dealXgId?: string; dealXgVersion?: string } = {}
) => {
    const offerType = (state: StateTree) => {
        const value = getCurrentOfferType(state);
        if (value === 'finance') return 'Finance';
        else return 'Lease';
    };

    const dealRefId = getDealRefIdFS(state);
    const dealXgId = overrides.dealXgId || getDealXgId(state);
    const dealXgVersion = overrides.dealXgVersion || getDealXgVersion(state);
    const sourceApplication = appPrefix === MANAGER_VIEW_APP_PREFIX ? 'ManagerView' : 'DealerView';
    const lenderId = getSelectedCreditDecision(state).lenderId;
    const financeMethod = offerType(state);
    const sourcePartnerId = getContractingSourcePartnerId(state);
    const correlationId = nanoid();
    const routeOnePartyId = dealerSelectors.getRouteOnePartyId(state);

    const dealerId = dealerSelectors.getDealerId(state);
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '/pushToFI');
    const endpoint = bffApiUrlResult.url;

    const body = JSON.stringify({
        sourcePartnerId,
        sourceApplication,
        dealerId,
        dealRefId,
        dealXgDealId: dealXgId,
        dealXgDealVersion: dealXgVersion,
        financeMethod,
        targetPlatforms: [
            {
                id: 'R1J',
                partyId: routeOnePartyId
            }
        ],
        lenderId
    });

    return {
        [RSAA]: {
            endpoint,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-coxauto-correlation-id': correlationId
            },
            body,
            types: [PUSH_TO_ROUTEONE_REQUEST, PUSH_TO_ROUTEONE_SUCCESS, PUSH_TO_ROUTEONE_FAILURE]
        }
    };
};
